import React, { FunctionComponent } from 'react';

import { MotorFullPageProps } from 'scenes/motor/types';
import { getClaimsMade, getDriverType } from 'scenes/motor/selectors';
import { ClaimsMadeStep as CommonClaimsMadeStep } from 'scenes/common/components/Steps';

const ClaimsMadeStep: FunctionComponent<MotorFullPageProps> = ({
  flowType,
  funnelState,
  onNext,
}) => {
  const driverType = getDriverType(flowType);
  return (
    <CommonClaimsMadeStep
      onNext={onNext}
      question={`In the last 3 years, how many claims has the ${driverType} driver made?`}
      defaultStateValue={getClaimsMade(funnelState)}
    />
  );
};

export default ClaimsMadeStep;
